import { IClient, IService } from '../../../model/common.model';
import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../confirm-dialog/confirm-dialog.component';
import { ClientStatusService } from '../../status/client-status.service';
import { EcaGenericMessageDialogComponent, EcaGenericMessageDialogConfig } from '@drc-eca/eca-components-lib';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { AddUpdateServiceModalComponent } from '../add-update-service-modal/add-update-service-modal.component';
import { UntypedFormGroup } from '@angular/forms';
import { ViewServiceClientsModalComponent } from '../view-service-clients-modal/view-service-clients-modal.component';

@Component({
    selector: 'app-update-service',
    standalone: true,
    templateUrl: './update-service.component.html',
    styleUrls: ['./update-service.component.scss'],
    imports: [MatTableModule, MatButtonModule]
})
export class UpdateServiceComponent implements OnInit {
  private clientStatusService = inject(ClientStatusService);
  dialog = inject(MatDialog);
  private clientStatusSvc = inject(ClientStatusService);

  serviceList: IService[] = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['name', 'description', 'associatedclients', 'action'];
  
  inprogress: boolean = false;
  clientList: IClient[] = [];

  dialogRef: MatDialogRef<ConfirmDialogComponent>;

  ngOnInit() {
    this.getServices();
    this.getClients();
  }

  getServices = () => {
    this.serviceList = [];
    this.clientStatusService.doGet('admin/service').subscribe((data: IService[]) => {
      this.serviceList = this.clientStatusService.sortArray(data || [], 'name', 'asc');
      this.dataSource.data = this.serviceList;
    }, () => {
      this.clientStatusService.showWarning('Error while getting existing services.');
    });
  }

  getClients = () => {
    this.clientList = [];
    this.clientStatusSvc.doGet('admin/client').subscribe((data: IClient[]) => {
      this.clientList = this.clientStatusSvc.sortArray(data || [], 'code', 'asc');      
    }, (error: any) => {
      this.clientStatusSvc.showWarning(`Error while getting existing clients.`, error.message ? error.message : null);
    });
  }

  openAddUpdateServiceModal(selectedService: IService = null) {
    const serviceDialogRef = this.dialog.open(AddUpdateServiceModalComponent, {
      data: {
        selectedService: selectedService
      }
    });

    serviceDialogRef.afterClosed().subscribe((result: { cancel: boolean, form: UntypedFormGroup }) => {
      let action = 'Add';
      if (!result.cancel) {
        let payload = {};
        if (selectedService) {
          payload = selectedService;
          action = 'Update';
        }
        payload['name'] = result.form.controls['name'].value;
        payload['description'] = result.form.controls['description'].value;
        this.addService(payload, action);
      }
    });
  }

  addService = (payload: any, action: string) => {
    if (payload) {
      this.clientStatusService.doPost('admin/service', payload).subscribe(() => {
        this.clientStatusService.showSuccess(`${action} service ${payload.name} success.`);
        this.getServices();

      }, () => {
        this.clientStatusService.showWarning(`Failed to ${action} service ${payload.name}.`);
      });
    }
  }

  deleteService = (service: IService) => {
    this.clientStatusService.doDelete('admin/service', service.primaryKeyPart).subscribe(() => {
      this.clientStatusService.showSuccess(`Service ${service.name} deleted successfully.`);
      this.getServices();
    }, () => {
      this.clientStatusService.showWarning(`Failed to delete service ${service.name}.`);
    });
  }

  openConfirmationDialog(service: IService) {
    const dialogConfig: MatDialogConfig<EcaGenericMessageDialogConfig> = {
      data: {
        title: `Delete Service ${service.name}`,
        message: `Deleting service will remove from client association too. Are you sure you want to delete "${service.name}" service?`,
        buttons: {
          negative: { label: 'Cancel' },
          positive: { label: 'Delete' }
        }
      },
      maxWidth: '650px'
    };

    const dialogRef = this.dialog.open(EcaGenericMessageDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteService(service);
      }
    });
  }

  viewAssociatedClients(selectedService: any){
    const viewDialog = this.dialog.open(ViewServiceClientsModalComponent, {
      data: {
        selectedService: selectedService,
        clientList: this.clientList
      }
    });
    viewDialog.afterClosed().subscribe(()=>{});
  }

}
